module.exports = __webpack_public_path__ + "img/cart-minus.fb06560d.svg";